import BaseButtonDropdown from "./BaseButtonDropdown.vue";

export type { Props } from "./BaseButtonDropdown.vue";
export default BaseButtonDropdown;
